import React from 'react';
import { Popover, Box, IconButton } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import classes from './Filter.module.scss';

const Filter = ({
  filterIcon,
  filterDropdown,
  title,
  handleChangeFilter,
  dataIndex,
  value = [],
}) => {
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedKeys, setSelectedKeys] = React.useState(value || []);
  const previousValue = React.useRef([]);

  const handleApply = React.useCallback(
    (nextSelected) => {
      setOpen(false);
      setSelectedKeys(nextSelected || selectedKeys);
      handleChangeFilter({
        [dataIndex]: nextSelected || selectedKeys,
      });
    },
    [selectedKeys, previousValue]
  );

  const handleReset = () => {
    setSelectedKeys([]);
    handleChangeFilter({
      [dataIndex]: [],
    });
  };
  return (
    <Box>
      <Box display='flex' alignItems='center'>
        <span style={{ marginRight: '4px' }}>{title}</span>
        <IconButton
          className={selectedKeys.length > 0 ? classes.filtering : ''}
          onClick={(event) => {
            setAnchorEl(event.currentTarget || event.target);
            setOpen(true);
          }}>
          {filterIcon || <FilterListIcon />}
        </IconButton>
      </Box>
      <Popover
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={() => {
          setOpen(false);
          // setAnchorEl(null);
        }}>
        {filterDropdown({
          selectedKeys,
          setSelectedKeys,
          confirm: (selected) => {
            previousValue.current = selected || selectedKeys;
            handleApply(selected);
          },
          clearFilters: () => {
            handleReset();
          },
        })}
      </Popover>
    </Box>
  );
};

export default Filter;
